import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import DateTime from '_class/DateTime';
import User from '_class/User';
import { getScheduleItem } from 'actions/schedule';
import { deleteReportedAttendance, getAttendence, getForecast } from 'actions/absence';
import Modal from 'containers/Modals/Modal';
import AttendanceHistory from 'containers/Lesson/Partials/AttendanceHistory';
import ReportHistory from 'containers/Lesson/Partials/ReportHistory';
import { Spinner } from 'UI';
import { Checkbox, Button, ButtonGroup, Table, Icon, translate } from '@haldor/ui';

var UserAbsence = /*#__PURE__*/function (_Component) {
  _inherits(UserAbsence, _Component);

  var _super = _createSuper(UserAbsence);

  function UserAbsence(props) {
    var _this;

    _classCallCheck(this, UserAbsence);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "setStudentValue", function (student, type) {
      var valid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var late = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      return new Promise(function (resolve) {
        var values = JSON.parse(JSON.stringify(_this.state.values));

        var foundExisting = _this.state.values.findIndex(function (value) {
          return value.user.userId == student.userId;
        });

        if (foundExisting > -1) {
          values[foundExisting].type = type;

          if (valid != null) {
            values[foundExisting].valid = valid;
          } else {
            values[foundExisting].valid = type.indexOf('VALID') == 0;
          }

          if (late != null) {
            values[foundExisting].lateDuration = late;
          } else {
            values[foundExisting].lateDuration = '';
          }
        } else {
          values.push({
            user: {
              userId: student.userId
            },
            valid: valid != null ? valid : type.indexOf('VALID') == 0,
            type: type,
            lateDuration: late,
            absenceRecordId: null
          });
        }

        _this.setState({
          values: values
        }, function () {
          resolve(1);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getStudentValue", function (student) {
      var foundExisting = _this.state.values.findIndex(function (value) {
        return value.user.userId == student.userId;
      });

      if (foundExisting > -1) {
        return _this.state.values[foundExisting];
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.schedule.attendanceReported != null) {
        // This lesson has attendence
        _this.props.getAttendence(_this.props.schedule.id).then(function () {
          _this.setValues();
        });
      } else {
        _this.props.getAttendence(_this.props.schedule.id);

        _this.props.getForecast(_this.props.schedule.id).then(function () {
          _this.setValues();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setValues", function () {
      var items = _this.props.forecast;
      var values = [];

      if (_this.props.schedule.attendanceReported) {
        items = _this.props.attendance;
      }

      if (items == null) {
        _this.setState({
          loading: false
        });

        return true;
      }

      var students = [];
      items.forEach(function (item) {
        item.validAbsent = item.type == "VALID_ABSENCE" || item.type == "VALID_LATE"; // if item.user is not in students, add it

        if (students.findIndex(function (student) {
          return student.userId == item.user.userId;
        }) == -1) {
          students.push(item.user);
        }
      });
      students.forEach( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(student) {
          var studentItems, value, hasInvalid, hasValid, hasLate, lateDuration, type;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  studentItems = items.filter(function (item) {
                    return item.user.userId == student.userId && item.status != 'Deleted';
                  });
                  value = {
                    user: {
                      userId: student.userId
                    },
                    valid: false,
                    type: 'PRESENT',
                    lateDuration: '',
                    absenceRecordId: null,
                    id: 0
                  };
                  hasInvalid = false;
                  hasValid = false;
                  hasLate = false;
                  lateDuration = 0;
                  studentItems.forEach(function (item) {
                    if (item.type.indexOf('VALID') == 0) {
                      hasValid = true;
                    }

                    if (item.type.indexOf('INVALID') == 0) {
                      hasInvalid = true;
                    }

                    if (item.type.indexOf('LATE') > -1) {
                      hasLate = true;
                    }

                    if (item.lateDuration != null) {
                      lateDuration += item.lateDuration;
                    }

                    value.id = item.id;

                    if (item.absenceRecordId != null) {
                      value.absenceRecordId = item.absenceRecordId;
                    }
                  });
                  type = 'PRESENT';

                  if (hasValid || hasInvalid) {
                    type = 'ABSENCE';
                  }

                  if (hasLate) {
                    type = 'LATE';
                  }

                  if (!(hasInvalid && hasValid)) {
                    _context.next = 15;
                    break;
                  }

                  value.type = 'INVALID_' + type;
                  value.valid = false;
                  values.push(value);
                  return _context.abrupt("return", true);

                case 15:
                  if (!hasLate) {
                    _context.next = 19;
                    break;
                  }

                  if (hasValid) {
                    value.type = 'VALID_' + type;
                    value.valid = true;
                    value.lateDuration = lateDuration + '';
                  } else {
                    value.type = 'INVALID_' + type;
                    value.valid = false;
                    value.lateDuration = lateDuration + '';
                  }

                  values.push(value);
                  return _context.abrupt("return", true);

                case 19:
                  if (!hasValid) {
                    _context.next = 24;
                    break;
                  }

                  value.type = 'VALID_' + type;
                  value.valid = true;
                  values.push(value);
                  return _context.abrupt("return", true);

                case 24:
                  if (!hasInvalid) {
                    _context.next = 29;
                    break;
                  }

                  value.type = 'INVALID_' + type;
                  value.valid = false;
                  values.push(value);
                  return _context.abrupt("return", true);

                case 29:
                  value.type = 'PRESENT';
                  values.push(value);

                case 31:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());

      _this.setState({
        values: values,
        loading: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function () {
      if (_this.props.onSubmit) {
        _this.setState({
          submitting: true
        });

        _this.props.onSubmit(_this.state.values).then(function () {
          _this.setState({
            submitting: false
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getReportedBy", function (item) {
      if (item.reportedBy != null && item.reportedBy.firstName != null) {
        var reportedBy = new User(item.reportedBy);
        return reportedBy.getName();
      }

      if (item.reportedBy != null) {
        if (item.reportedBy.userId == 'TrackAttendance') {
          return _this.props.translate('system');
        }

        if (item.reportedBy != '') {
          return _this.props.translate('Guardian');
        }
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderUserAbsentActions", function (student) {
      var status = _this.getStudentValue(student).type;

      var prefix = 'INVALID_';

      if (status.indexOf('VALID') == 0) {
        prefix = 'VALID_';
      }

      return /*#__PURE__*/React.createElement(ButtonGroup, null, status == 'PRESENT' || status == 'VALID_PRESENT' ? /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick(e) {
          return _this.setStudentValue(student, 'PRESENT');
        },
        style: {
          backgroundColor: '#4baf4d',
          borderColor: '#4baf4d'
        }
      }, _this.props.translate('present')) : /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: function onClick(e) {
          return _this.setStudentValue(student, 'PRESENT');
        }
      }, _this.props.translate('present')), status == 'INVALID_ABSENCE' || status == 'VALID_ABSENCE' ? /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick(e) {
          return _this.setStudentValue(student, prefix + 'ABSENCE');
        },
        style: {
          backgroundColor: '#df2d2e',
          borderColor: '#df2d2e'
        }
      }, _this.props.translate('absent-whole')) : /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: function onClick(e) {
          return _this.setStudentValue(student, prefix + 'ABSENCE');
        }
      }, _this.props.translate('absent-whole')), status == 'INVALID_LATE' || status == 'VALID_LATE' ? /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick(e) {
          return _this.setStudentValue(student, prefix + 'LATE');
        },
        style: {
          backgroundColor: '#f38234',
          borderColor: '#f38234'
        }
      }, _this.props.translate('late-partly')) : /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: function onClick(e) {
          return _this.setStudentValue(student, prefix + 'LATE');
        }
      }, _this.props.translate('late-partly')));
    });

    _defineProperty(_assertThisInitialized(_this), "onMinutesChange", function (minutes, student) {
      minutes = minutes.replace(/[^\d]/, '');

      var userValue = _this.getStudentValue(student);

      if (parseInt(minutes) !== 0) {
        if (parseInt(minutes) > _this.props.schedule.length) {
          _this.setStudentValue(student, userValue.type, null, _this.props.schedule.length);
        } else {
          _this.setStudentValue(student, userValue.type, null, parseInt(minutes));
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeValidAbsence", function (student) {
      var type = null;

      var item = _this.getStudentValue(student);

      if (item.type == "VALID_ABSENCE") {
        type = "INVALID_ABSENCE";
      } else if (item.type == "VALID_LATE") {
        type = "INVALID_LATE";
      } else if (item.type == "INVALID_ABSENCE") {
        type = "VALID_ABSENCE";
      } else if (item.type == "INVALID_LATE") {
        type = "VALID_LATE";
      } else {
        type = 'PRESENT';
      }

      _this.setStudentValue(student, type, type.indexOf('INVALID') == -1, item.lateDuration);
    });

    _defineProperty(_assertThisInitialized(_this), "renderTable", function (items) {
      var translate = _this.props.translate;

      if (items == null || items.length == 0) {
        return /*#__PURE__*/React.createElement("div", {
          className: "color--meta text--center weight--bold"
        }, _this.props.translate('no-results'));
      }

      var students = [];
      items.forEach(function (item) {
        item.validAbsent = item.type == "VALID_ABSENCE" || item.type == "VALID_LATE"; // if item.user is not in students, add it

        if (students.findIndex(function (student) {
          return student.userId == item.user.userId;
        }) == -1) {
          students.push(item.user);
        }
      });
      return /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, _this.props.translate('name')), /*#__PURE__*/React.createElement("th", null, _this.props.translate('absent')), /*#__PURE__*/React.createElement("th", null, _this.props.translate('minutes')), /*#__PURE__*/React.createElement("th", null, _this.props.translate('mark-for-valid-absence')), /*#__PURE__*/React.createElement("th", null, _this.props.translate('Absence length')), /*#__PURE__*/React.createElement("th", null, _this.props.translate('reported-by')), /*#__PURE__*/React.createElement("th", null, _this.props.translate('reported')))), /*#__PURE__*/React.createElement("tbody", null, students.map(function (student) {
        var user = new User(student);
        var studentItems = items.filter(function (item) {
          return item.user.userId == student.userId;
        });

        var value = _this.getStudentValue(student);

        var hasHistory = false;
        studentItems.forEach(function (item) {
          if (item.history != null && item.history.length > 0) {
            var history = item.history.filter(function (item) {
              return item.status != 'Deleted';
            });
            hasHistory = history.length > 0;
          }
        });
        return /*#__PURE__*/React.createElement("tr", {
          key: student.userId
        }, /*#__PURE__*/React.createElement("td", {
          title: student.email,
          onClick: function onClick() {
            return _this.onStudentSelect(student);
          },
          style: {
            cursor: 'pointer'
          }
        }, hasHistory ? /*#__PURE__*/React.createElement(Icon, {
          name: "History"
        }) : null, user.getName()), /*#__PURE__*/React.createElement("td", {
          style: {
            whiteSpace: 'nowrap',
            verticalAlign: 'top'
          }
        }, _this.renderUserAbsentActions(student)), /*#__PURE__*/React.createElement("td", {
          style: {
            textAlign: 'left',
            width: 60,
            verticalAlign: 'top'
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "form-row"
        }, value.type.indexOf('LATE') > -1 ? /*#__PURE__*/React.createElement("input", {
          style: studentItems.length > 1 ? {
            width: 60,
            marginBottom: 3
          } : {
            width: 60
          },
          type: "number",
          min: "0",
          max: _this.props.schedule.length,
          value: value.lateDuration,
          onWheel: function onWheel() {
            return document.activeElement.blur();
          },
          onChange: function onChange(e) {
            return _this.onMinutesChange(e.target.value, student);
          }
        }) : /*#__PURE__*/React.createElement("div", {
          style: {
            width: 60,
            height: 23,
            marginBottom: 3
          }
        }), studentItems.length > 1 ? studentItems.map(function (item, index) {
          if (item.lateDuration == null) {
            return null;
          }

          return /*#__PURE__*/React.createElement("div", {
            key: index,
            style: {
              height: 35
            }
          }, /*#__PURE__*/React.createElement("input", {
            style: {
              width: 60
            },
            type: "number",
            min: "0",
            max: _this.props.schedule.length,
            value: item.lateDuration,
            disabled: true
          }));
        }) : null)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          style: studentItems.length > 1 ? {
            marginBottom: 3
          } : {}
        }, value.type != 'PRESENT' && value.type != 'VALID_PRESENT' ? /*#__PURE__*/React.createElement(Checkbox, {
          value: value.valid,
          onChange: function onChange() {
            _this.onChangeValidAbsence(student);
          }
        }) : null), studentItems.length > 1 ? studentItems.map(function (item, index) {
          return /*#__PURE__*/React.createElement("div", {
            key: index,
            style: {
              height: 35
            }
          }, /*#__PURE__*/React.createElement(Checkbox, {
            value: item.type.indexOf('VALID') == 0,
            style: {
              "float": 'right'
            },
            disabled: true
          }));
        }) : null), /*#__PURE__*/React.createElement("td", null, studentItems.length == 1 ? studentItems[0].reported != null && studentItems[0].endTime != null ? /*#__PURE__*/React.createElement("div", null, translate('From'), ": ", new DateTime(studentItems[0].startTime).getHourStamp(), /*#__PURE__*/React.createElement("br", null), translate('To'), ": ", new DateTime(studentItems[0].endTime).getHourStamp()) : null : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("br", null), studentItems.map(function (item, index) {
          return /*#__PURE__*/React.createElement("div", {
            key: index
          }, translate('From'), ": ", new DateTime(item.startTime).getHourStamp(), /*#__PURE__*/React.createElement("br", null), translate('To'), ": ", new DateTime(item.endTime).getHourStamp(), /*#__PURE__*/React.createElement("br", null));
        }))), /*#__PURE__*/React.createElement("td", null, studentItems.length == 1 ? _this.getReportedBy(studentItems[0]) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("br", null), studentItems.map(function (item, index) {
          return /*#__PURE__*/React.createElement("div", {
            key: index
          }, _this.getReportedBy(item), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null));
        }))), /*#__PURE__*/React.createElement("td", null, studentItems.length == 1 ? studentItems[0].reported != null ? new DateTime(studentItems[0].reported).getHourStamp() : null : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("br", null), studentItems.map(function (item, index) {
          return /*#__PURE__*/React.createElement("div", {
            key: index
          }, item.reported != null ? new DateTime(item.reported).getHourStamp() : null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null));
        }))));
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "onStudentSelect", function (student) {
      var item = student;
      item.items = [];

      if (_this.props.attendance != null) {
        item.items = _toConsumableArray(_this.props.attendance).filter(function (attendance) {
          return attendance.user.userId == student.userId;
        });
      }

      _this.setState({
        selectedStudent: item
      });
    });

    _defineProperty(_assertThisInitialized(_this), "deleteAttendance", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this.setState({
                loading: true
              });

            case 2:
              _this.props.deleteReportedAttendance(_this.props.schedule.id).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _this.props.schedule.attendanceReported = false;
                        _context2.next = 3;
                        return _this.props.getScheduleItem(_this.props.schedule.id);

                      case 3:
                        _context2.next = 5;
                        return _this.props.getForecast(_this.props.schedule.id);

                      case 5:
                        _context2.next = 7;
                        return _this.props.getAttendence(_this.props.schedule.id);

                      case 7:
                        _this.setValues();

                      case 8:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              })));

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));

    _this.state = {
      selectedStudent: null,
      loading: true,
      submitting: false,
      reported: props.schedule.attendanceReported != null,
      values: []
    };
    return _this;
  }

  _createClass(UserAbsence, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var schedule = this.props.schedule;
      var selectedStudent = this.state.selectedStudent;
      var reported = schedule.attendanceReported != null;

      if (schedule == null) {
        return null;
      }

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "form"
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: selectedStudent != null,
        title: this.props.translate('Attendance for') + ' ' + (selectedStudent === null || selectedStudent === void 0 ? void 0 : selectedStudent.firstName) + ' ' + (selectedStudent === null || selectedStudent === void 0 ? void 0 : selectedStudent.lastName),
        onClose: function onClose() {
          return _this2.setState({
            selectedStudent: null
          });
        },
        overridePrompt: true
      }, /*#__PURE__*/React.createElement(AttendanceHistory, {
        student: selectedStudent
      })), reported ? this.renderTable(this.props.attendance) : this.renderTable(this.props.forecast), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1.5rem',
          marginLeft: '1.7rem'
        }
      }, reported ? /*#__PURE__*/React.createElement(Button, {
        type: "save",
        onClick: this.onSubmit
      }, this.state.submitting ? /*#__PURE__*/React.createElement(Spinner, {
        center: true,
        small: true
      }) : null, reported ? this.props.translate('update-report') : this.props.translate('save-report')) : null, !reported && this.props.forecast ? /*#__PURE__*/React.createElement(Button, {
        type: "save",
        onClick: this.onSubmit
      }, this.state.submitting ? /*#__PURE__*/React.createElement(Spinner, {
        center: true,
        small: true
      }) : null, reported ? this.props.translate('update-report') : this.props.translate('save-report')) : null, reported ? /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginLeft: '1rem'
        },
        onClick: this.deleteAttendance
      }, this.state.submitting ? /*#__PURE__*/React.createElement(Spinner, null) : null, this.props.translate('Remove report')) : null), /*#__PURE__*/React.createElement(ReportHistory, {
        attendance: this.props.attendance
      }));
    }
  }]);

  return UserAbsence;
}(Component);

function mapStateToProps(state) {
  return {
    user: state.user.currentUser,
    attendance: state.Absence.calendarAttendence,
    translate: translate(state.Languages.translations),
    forecast: state.Absence.forecast,
    schedule: state.schedule.activeScheduleItem
  };
}

;
export default connect(mapStateToProps, {
  getAttendence: getAttendence,
  getForecast: getForecast,
  deleteReportedAttendance: deleteReportedAttendance,
  getScheduleItem: getScheduleItem
})(UserAbsence);